import { setIsOptionalExperiencesPolicyEnabledMutator } from '../mutators/setIsOptionalExperiencesPolicyEnabled';
import getStore from '../store/store';
import { getOptionalExperiencesPolicy } from './getOptionalExperiencesPolicy';

export function isOptionalExperiencesAllowedByPolicy(): boolean {
    const observablePolicyValue = getStore().isOptionalConnectedExperiencesPolicyEnabled;

    if (observablePolicyValue === undefined) {
        const policyValue = getOptionalExperiencesPolicy();
        setIsOptionalExperiencesPolicyEnabledMutator(policyValue);

        return policyValue;
    }

    return observablePolicyValue;
}
